import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./HomePage.css";
import works1 from "./../../../assets/works1.webp";
import works2 from "./../../../assets/works2.webp";
import works3 from "./../../../assets/works3.webp";
import playstore from "./../../../assets/playstore.webp";
import footer_page from "./../../../assets/footer_page.webp";
import { connect, useDispatch } from "react-redux";
import { currentLocationInfo } from "../redux/actions";
import { currentAddressrequest } from "../util/currentAddress";
import { storeCategories } from "../redux/actions";
import { storeServices } from "../redux/actions";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { maintainStoretype } from "../redux/actions";
import { Modal, Row } from "react-bootstrap";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import { fetchLogindata, setStoreIpAddress } from "../../login/redux/actions";
import { fetchStoredetail } from "../../dashboard/redux/actions";
import { maintainCartdata } from "../../home/redux/actions";
import { storeConnection } from "../../header/redux/actions";
import { storeChathistory } from "../../header/redux/actions";
import { fetchChatuserlist } from "../../header/redux/actions";
import storage from "redux-persist/lib/storage";
import { LazyLoadImage } from "react-lazy-load-image-component";
import apple from "../../../assets/apple.svg";
import ExplorecabPage from "../../vehicle/explorecab/components/ExplorecabPage";
import { SERVICES } from "../../constants/apiurl";
import { getRequestcall, reverseGeocode } from "../../comman/util/getRequest";
import PlaceautocompletePage from "../../comman/components/PlaceautocompletePage";
import CategorycardPage from "../../comman/components/CategorycardPage";
import { setStoreMessageReceived } from "../../chat/redux/actions";

function HomePage(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [address, setAddress] = useState("");
  const [placaddress, setPlaceaddress] = useState(t("pages.home.enter_location"));
  const [showLocation, setShowlocation] = useState(false);

  let service_card = {
    height: "160px",
    minHeight: "0px",
  }

  let goods_card = {
    minHeight: "380px"
  }

  // eslint-disable-next-line
  useEffect(() => {
    (async () => getCategories())();
    // eslint-disable-next-line
  }, [location, props?.language]);

  // eslint-disable-next-line
  useEffect(() => {
    if (location?.state?.autologout === true) {
      clearReduxdata();
    }
    // eslint-disable-next-line
  }, [location?.state?.autologout]);

  const clearReduxdata = () => {
    dispatch(setStoreIpAddress(""));
    storage.removeItem("persist:persist-store");
    props.fetchLogindata({});
    props.fetchStoredetail([]);
    props.maintainCartdata([], {});
    props.fetchChatuserlist([]);
    props.storeConnection({});
    dispatch(setStoreMessageReceived({messages:[], users_id:""}))
  };

  const getCategories = async () => {
    let getserviceurl = SERVICES + `?lang=${props?.language?.toLowerCase()}`;
    let getCategories = await getRequestcall(getserviceurl, "");
    if (getCategories?.status === 200) {
      let getservices = await getCategories.json();
      let value = {};
      let getAll = [];
      getservices?.data?.forEach((item) => {
        value = {
          ...item,
          id: item.id,
          image: item.image,
          image_url: item.image_url,
          sid: item.sid,
          web_image_url: item?.web_image_url,
          title: item.title,
          type: item.type,
          is_checked: false,
          list: [],
        };
        getAll.push(value);
      });
      let getService = getAll.filter((item) => item.type === "service");
      props.storeServices(getService);
      props.storeCategories(getAll);
    }
    props?.fetchHeaderContent(t("pages.meta.home_page.title"), t("pages.meta.home_page.description"), "");
    if ((props?.currentLocation?.lat === "" ||
      typeof props?.currentLocation?.lat === "undefined") &&
      (props?.currentLocation?.selectedLocation === "" ||
        typeof props?.currentLocation?.selectedLocation === "undefined")) {
      getCurrentLocation();
    } else {
      setShowlocation(false);
    }
  };

  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(currentLocation, showError);
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  const showError = (error) => {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        if (navigator?.userAgentData?.platform !== "macOS" && typeof navigator?.userAgentData?.platform !== "undefined") {
          getCurrentLocation();
        }
        setShowlocation(true);
        break;
      case error.POSITION_UNAVAILABLE:
        break;
      case error.TIMEOUT:
        break;
      case error.UNKNOWN_ERROR:
        break;
      default:
        break;
    }
  };

  const currentLocation = (position) => {
    setShowlocation(false)
    var lat = position.coords.latitude;
    var lng = position.coords.longitude;
    currentAddress(lat, lng);
  };

  const currentAddress = async (lat, lng) => {
    if (
      (props?.currentLocation?.lat === "" ||
        typeof props?.currentLocation?.lat === "undefined") &&
      (props?.currentLocation?.lng === "" ||
        typeof props?.currentLocation?.lng === "undefined")
    ) {
      getCurrentaddress(lat, lng);
    } else {
      if (location?.state?.autologout === true) {
        getCurrentaddress(lat, lng);
      }
    }
  };

  const getCurrentaddress = async (lat, lng) => {
    const currentAddressresponse = await currentAddressrequest(lat, lng);
    if (currentAddressresponse?.status === 200) {
      const getlist = await currentAddressresponse.json();
      let currentLocation = {
        lat: lat,
        lng: lng,
        address: "",
        selectedLocation: "",
        city: "",
        country: "",
        state: "",
        zip_code: "",
        isocode: "",
      };
      getlist?.results[0]?.address_components.forEach((item) => {
        switch (item.types[0]) {
          case "locality":
            currentLocation.city = item.long_name;
            break;
          case "administrative_area_level_1":
            currentLocation.state = item.long_name;
            break;
          case "country":
            currentLocation.country = item.long_name;
            currentLocation.isocode = item.short_name;
            break;
          default:
            break;
        }
      });
      const latitude = lat;
      const longitude = lng;

      let zipCode = await reverseGeocode({ latitude, longitude });
      currentLocation.zip_code = zipCode
      currentLocation.address =
        currentLocation.city +
        " " +
        currentLocation.state +
        " " +
        currentLocation.country +
        " " +
        currentLocation.zip_code;
      // use in chech out page
      currentLocation.selectedLocation = currentLocation.address;
      props.currentLocationInfo(currentLocation);
    }
  };

  const seeAllCategory = (storeType) => {
    props.maintainStoretype(storeType);
    navigate("category");
  };


  const seeAll = (title, text) => {
    return (
      <div className="main_seeall">
        <h5 className="header-title mb-0">{t("pages.home." + text)}</h5>
        <div
          onClick={() => seeAllCategory(title)}
          className="see_all text-white gap-2"
        >
          {t("pages.home.see_all")}
          <i className="icon_after arrow_right_icon" />
        </div>
      </div>
    )
  }

  const howItwork = (image, title, paragraph) => {
    return (
      <>
        <LazyLoadImage src={image} alt="" height={55} width={69} />
        <div className="d-flex flex-column">
          <h5 className="work-title mb-1">
            {t(title)}
          </h5>
          <p className="mb-0">{t(paragraph)}</p>
        </div>
      </>
    )
  }

  const appstoreButton = (image, paragraph, title) => {
    return (
      <>
        <LazyLoadImage
          alt={""}
          src={image}
          height="31"
          width="31"
          className={"play_logo me-2"}
        />
        <div className={"d-flex f-column"}>
          {
            props?.language === "Tr" ? (
              <>
                <h5 className={"mb-0"}>
                  {t(title)}
                </h5>
                <p className={"mb-0"}>
                  {t(paragraph)}
                </p>
              </>
            ) : (
              <>
                <p className={"mb-0"}>
                  {t(paragraph)}
                </p>
                <h5 className={"mb-0"}>
                  {t(title)}
                </h5>
              </>
            )
          }
     </div>
      </>
    )
  }

  return (
    <>
      <div className="home_page">
        <div className="home-content">
          <div className="container-xl mb-5">
            <ExplorecabPage />
            {seeAll("goods", "goods")}
            <Row className="row home_product_container">
              {props?.categories?.map(
                (item, index) =>
                  window.innerWidth > 767 ? (
                    index < 4 && (
                      <CategorycardPage key={index?.toString()} card_style={goods_card} item={item} type={"goods"} />
                    )
                  ) : (
                    item?.type === "goods" && (
                      index < 8 && (
                        <CategorycardPage key={index?.toString()} item={item} type={"goods"} />
                      )
                    )
                  )
              )
              }
            </Row>
            {seeAll("service", "services")}
            <Row className="row home_product_container">
              {props.serviceslist?.map(
                (item, index) =>
                  window.innerWidth > 767 ? (
                    index < 4 && (
                      <CategorycardPage key={index?.toString()} card_style={service_card} item={item} type={"service"} />
                    )) : (
                    index < 4 && (
                      <CategorycardPage key={index?.toString()} item={item} type={"service"} />
                    )
                  )
              )}
            </Row>
            <div className="row how_it_work">
              <h5 className="header-title mt-4 mb-4">
                {t("pages.home.how_works")}
              </h5>
              <div className="col-4">
                {howItwork(works1, "pages.home.create_account", "pages.home.states_area")}
              </div>
              <div className="col-4">
                {howItwork(works2, "pages.home.select_product", "pages.home.always_fresh")}
              </div>
              <div className="col-4">
                {howItwork(works3, "pages.home.deliver_shop", "pages.home.free_deliver")}
              </div>
            </div>
          </div>
          <div className="col-xl-12 mt-5 store-btn-section">
            <div className={"app_info_footer"}>
              <div className={"container"}>
                <div className={"row"}>
                  <div className={"col-6"}>
                    <h5 className={"header-title text-white"}>
                      {t("pages.home.appinfo.title")}
                    </h5>
                    <p className={"secound-title mb-4"}>
                      {t("pages.home.appinfo.download")}
                    </p>
                    <div className={"stores_btn"}>
                      <button className={"black_btn transition"} onClick={() => window.open("https://play.google.com/store/apps/details?id=com.girne", "_blank")}>
                        {appstoreButton(playstore, "pages.home.appinfo.btn_1.title1", "pages.home.appinfo.btn_1.title2")}
                      </button>
                      <button className={"black_btn transition"} onClick={() => window.open("https://apps.apple.com/in/app/girne/id6444398214", "_blank")}>
                        {appstoreButton(apple, "pages.home.appinfo.btn_2.title1", "pages.home.appinfo.btn_2.title2")}
                      </button>
                    </div>
                    <p className={"secound-title m-0"}>
                      {t("pages.home.appinfo.description")}
                    </p>
                  </div>
                  <div className={"col-6 mobile_image_div"}>
                    <LazyLoadImage
                      className={"footer_img_page"}
                      alt={""}
                      src={footer_page}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {showLocation && (props?.currentLocation?.lat === "" ||
          typeof props?.currentLocation?.lat === "undefined") &&
          (props?.currentLocation?.lng === "" ||
            typeof props?.currentLocation?.lng === "undefined")
          && (
            <Modal show={showLocation}>
              <Modal.Body>
                <div className="text-danger">
                  {t("pages.Please allow your location")}
                </div>
                <div className="mt-2">
                  <PlaceautocompletePage setAddress={setAddress} address={address} placaddress={placaddress} setPlaceaddress={setPlaceaddress} />
                  <div className="text-danger mt-2">{t("pages.home.enter_manually")}</div>
                </div>
              </Modal.Body>
            </Modal>
          )}
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login.access_token,
  categories: state?.home?.categories,
  serviceslist: state?.home?.serviceslist,
  currentLocation: state?.home?.currentLocation,
  language: state?.languageState?.language,
});

export default connect(mapStateToProps, {
  fetchLogindata,
  fetchStoredetail,
  maintainCartdata,
  storeConnection,
  storeChathistory,
  fetchChatuserlist,
  currentLocationInfo,
  storeCategories,
  maintainStoretype,
  storeServices,
  fetchHeaderContent
})(HomePage);
